<template>
    <div class="user-admin">
       <b-form v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
            <input id="user-id" type="hidden" v-model="user.id" />
            <b-row>
                <b-col md="4" sm="12">
                    <b-form-group label="Name:" label-for="user-name">
                        <b-form-input id="user-name" type="text" ref="searchFocus"
                            v-model="user.name" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read'"
                            placeholder="Name..." />
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                    <b-form-group label="E-mail:" label-for="user-email">
                        <b-form-input id="user-email" type="text"
                            v-model="user.email" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read'"
                            placeholder="E-mail..." />
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                    <b-form-group 
                        label="Company:" 
                        label-for="user-company_default_id">
                        <b-form-select 
                        id="user-company_default_id"
                        size="sm"
                        :disabled="mode === 'remove' || mode === 'read'"
                        :options="companys" v-model="user.company_default_id" />
                    </b-form-group>
                    </b-col>
            </b-row>
            <b-row>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                        <input class="form-check-input" 
                        v-model="user.admin" 
                        true-value="1" 
                        false-value="0" 
                        type="checkbox" 
                        id="user-admin"
                        :disabled="mode === 'remove' || mode === 'read'" >
                        <label class="form-check-label" for="user-admin">
                        Administrator?
                        </label>
                        </div>
                    </div>
                </b-col>
                 <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                        <input class="form-check-input" 
                        v-model="user.record_parther" 
                        true-value="1" 
                        false-value="0" 
                        type="checkbox" 
                        id="user-record_parther"
                        :disabled="mode === 'remove' || mode === 'read'" >
                        <label class="form-check-label" for="user-record_parther">
                        Parther menu?
                        </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
             <b-row>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                        <input class="form-check-input" 
                        v-model="user.record_tenant" 
                        true-value="1" 
                        false-value="0" 
                        type="checkbox" 
                        id="user-record_tenant"
                        :disabled="mode === 'remove' || mode === 'read'" >
                        <label class="form-check-label" for="user-record_tenant">
                        Tenant menu?
                        </label>
                        </div>
                    </div>
                </b-col>
                 <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                        <input class="form-check-input" 
                        v-model="user.record_owner" 
                        true-value="1" 
                        false-value="0" 
                        type="checkbox" 
                        id="user-record_owner"
                        :disabled="mode === 'remove' || mode === 'read'" >
                        <label class="form-check-label" for="user-record_owner">
                        Landlord menu?
                        </label>
                        </div>
                    </div>
                </b-col>
                 <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                        <input class="form-check-input" 
                        v-model="user.record_service_provider" 
                        true-value="1" 
                        false-value="0" 
                        type="checkbox" 
                        id="user-record_service_provider"
                        :disabled="mode === 'remove' || mode === 'read'" >
                        <label class="form-check-label" for="user-record_service_provider">
                        Service Provider menu?
                        </label>
                        </div>
                    </div>
                </b-col>
                 <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                        <input class="form-check-input" 
                        v-model="user.record_financial" 
                        true-value="1" 
                        false-value="0" 
                        type="checkbox" 
                        id="user-record_financial"
                        :disabled="mode === 'remove' || mode === 'read'" >
                        <label class="form-check-label" for="user-record_financial">
                        Financial menu?
                        </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-form>
        <b-row>
                <b-col xs="12">
                  <b-button  
                        title="Save"  
                        size="sm" 
                        variant="light" 
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save"></b-button>
                    <b-button  
                        title="Delete" 
                        size="sm" 
                        variant="light" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove"></b-button>
                    <b-button  
                        title="Back" 
                        size="sm" 
                        variant="light" 
                        class="mt-2 mb-2 ml-2 fa fa-ban"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button  
                    size="sm" 
                    title="Search" 
                    class="mt-2 mb-2 ml-2 fa fa-search" 
                    @click="[loadUsers()]" 
                    variant="light" 
                    v-show="mode !== 'save' && mode !== 'remove'"
                    >
                    </b-button>
                  
                </b-col>
            </b-row>
        <b-row v-show="mode !== 'save' && mode !== 'remove'">
        <div class="col-sm-6">
            <b-form-group> 
            <input size="lg" type="text" icon="search" v-model="search" placeholder="Search by user name" class="form-control">                  
            </b-form-group>
        </div>
        <b-table  class="table-responsive" hover striped :items="filteredList" :fields="fields">
        
            <template v-slot:cell(actions)="data">
                <b-button  size="sm" variant="light" @click="[loadUser(data.item),alterModo()]" class="mr-2 mt-2">
                    <i class="fa fa-pencil"></i>
                </b-button>
                <b-button  size="sm" variant="light" @click="loadUser(data.item, 'remove')" class="mr-2 mt-2">
                    <i class="fa fa-trash"></i>
                </b-button>
                <b-button  size="sm" v-b-modal.modalPassword variant="light" @click="loadUser(data.item)" class="mr-2 mt-2" >
                    <i class="fa fa-key"></i>
                </b-button>
                <b-button  size="sm"  v-b-modal.modalBlocked  variant="light" @click="loadUser(data.item)" class="mr-2 mt-2" >
                    <i class="fa fa-unlock-alt"></i>
                </b-button>
                 <b-button  size="sm" v-b-modal.modalUnBlocked  variant="light" @click="loadUser(data.item)" class="mr-2 mt-2" >
                    <i class="fa fa-unlock"></i>
                </b-button>
            </template>
        </b-table>
         </b-row>
          <b-modal id="modalPassword"
            ref="modal"
            title-tag = "h6"
            title="Change Password"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="passwordChange"
            >
             <b-row v-show="mode === 'save'">
                <b-col md="6" sm="12">
                    <b-form-group 
                        label="Password:" 
                        label-for="user-password">
                        <b-form-input 
                            id="user-password" 
                            type="password"
                            size="sm"
                            v-model="user.password"
                            placeholder="Password..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group 
                            label="Confirm the Password:" 
                            label-for="user-confirm-password">
                        <b-form-input 
                            id="user-confirm-password" 
                            type="password"
                            size="sm"
                            v-model="user.confirmPassword" 
                            placeholder="Confirm the Password..." />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-modal>
        <b-modal id="modalBlocked"
            ref="modal"
            title-tag = "h6"
            title="Block User"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="blocked"
            >
           <p class="my-4">This Procedure will remove user access. <b-badge>{{user.name}}</b-badge></p>

        </b-modal>
        <b-modal id="modalUnBlocked"
            ref="modal"
            title-tag = "h6"
            title="Unlock User"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="unblocked"
            >
           <p class="my-4" >This Procedure will allow user access. <b-badge>{{user.name}}</b-badge></p>

        </b-modal>
        
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'

export default {
    name: 'UserAdmin',
    data: function() {
        return {
            mode: 'insert',
            search: '',
            user: {},
            users: [],
            companys:[],
            setores: [],
            headerBgVariant: 'primary',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            fields: [
                { key: 'name', label: 'Name', sortable: true },
                { key: 'email', label: 'E-mail', sortable: false },
                { key: 'admin', label: 'Administrator', sortable: false,
                    formatter: value => value ? 'Yes' : 'No' },     
                { key: 'service_provider', label: 'Service Provider', sortable: false,
                    formatter: value => value ? 'Yes' : 'No' },       
                { key: 'tenant', label: 'Tenant', sortable: false,
                    formatter: value => value ? 'Yes' : 'No' },       
                { key: 'actions', label: 'Ações' , variant: 'secondary' }
            
            ],
            options: [
                { value: 1, text: 'yes' },
                { value: 0, text: 'no' }
               
            ]
        }
    },computed: {
        filteredList() {
        return this.users.filter(user => {
        return user.name.toLowerCase().includes(this.search.toLowerCase())
            })
        }
    },
    methods: {
        loadUsers() {
            const url = `${baseApiUrl}/users`
            axios.get(url).then(res => {
                this.users = res.data
            })
        },
        reset() {
            this.user = {}
            this.mode = 'insert'
            this.loadUsers()
        },
        alterModo() {
            this.mode = 'save'
                },
        save() {
            const method = this.user.id ? 'put' : 'post'
            const id = this.user.id ? `/${this.user.id}` : ''
            axios[method](`${baseApiUrl}/users${id}`, this.user)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        passwordChange() {
            const method = this.user.id ? 'put' : 'post'
            const id = this.user.id ? `/${this.user.id}` : ''
            axios[method](`${baseApiUrl}/passwordChange${id}`, this.user)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        remove() {
            const id = this.user.id
            axios.delete(`${baseApiUrl}/users/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        blocked() {
            const id = this.user.id
            axios.put(`${baseApiUrl}/blocked/${id}`,this.user)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        unblocked() {
            const id = this.user.id
            axios.put(`${baseApiUrl}/unblocked/${id}`, this.user)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        loadUser(user, mode = 'save') {
            this.mode = mode
            this.user = { ...user }
            this.$refs.searchFocus.focus();
        },
        loadSetores() {
            const url = `${baseApiUrl}/setores`
            axios.get(url).then(res => {
                this.setores = res.data.map(setor => {
                    return { value: setor.id, text: setor.nome_setor }
                })
            })
        },
        loadCompanys() {
            const url = `${baseApiUrl}/companys`
            axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
}
    },
    mounted() {
        this.loadCompanys()
        this.loadUsers()
        this.loadSetores()
    }
}
</script>

<style>

    .user-admin {
        font-size: 0.75rem;
          background: linear-gradient(to right, #141e30, #243b55);
   
    }

    .user-admin select{
        font-size: 0.75rem;
    }
    .user-admin input{
        font-size: 0.75rem;
    }
    .user-admin button{
        font-size: 0.75rem;
    }
    .user-admin table{
        font-size: 0.75rem;
    }

      .user-admin label{
        font-size: 0.75rem;

    }

    #modalPassword{
         font-size: 0.8rem;
    }

    #modalPassword label{
         font-size: 0.8rem;
    }

    #modalPassword button{
         font-size: 0.8rem;
    }

    #modalPassword input{
        font-size: 0.8rem;
    }

    #modalBlocked{
         font-size: 0.75rem;
    }

    #modalBlocked label{
         font-size: 0.75rem;
    }

    #modalBlocked button{
         font-size: 0.75rem;
    }

     #modalUnBlocked{
         font-size: 0.75rem;
    }

    #modalUnBlocked label{
         font-size: 0.75rem;
    }

    #modalUnBlocked button{
         font-size: 0.75rem;
    }
    

</style>
